import { render, staticRenderFns } from "./dilu-table.vue?vue&type=template&id=6bd9e18f&scoped=true&"
import script from "./dilu-table.vue?vue&type=script&lang=js&"
export * from "./dilu-table.vue?vue&type=script&lang=js&"
import style0 from "./dilu-table.vue?vue&type=style&index=0&id=6bd9e18f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd9e18f",
  null
  
)

export default component.exports